import React from 'react'

const CommunityVenturePortfolioBanner = () => {
  return (
    <>
            {/* <!-- Online CV Area Start --> */}
            <div className="online-cv cv-bg section-overly pt-90 pb-120"  style={{background: "url('../assets/img/gallery/how-applybg.png')", backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}} >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-10">
                        <div className="cv-caption text-center">
                            <p className="pera1">We're Happy to Announce our Partnership for the:</p>
                            <p className="pera2"> Community Venture Portfolio Program</p>
                            <p className="text-white">Find & Deliver simple community-based tasks outside your routine work hours and get paid.</p>
                            <br />
                            <a href="/community-venture-portfolio" className="border-btn2 border-btn4">Read More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- Online CV Area End--> */}
    </>
  )
}

export default CommunityVenturePortfolioBanner